<div class="modal-header main-modal-header">
    <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="dismissModal()">×</button>
    <h4 class="modal-title wrap-text-in ng-binding">
        <span>{{ actionLabel }}</span>
    </h4>
</div>
    
<div class="modal-body">
    <div class="row">
        <div class="col-xs-12" *ngIf="actionType == 'addEmployee'">
            <app-add-edit-employee [isPopup]="true" (saveCallback)="onEmployeeAdded($event)"></app-add-edit-employee>
        </div>
    </div>
</div>